import React, { useState, useCallback, useEffect } from "react";
import { Box, Card, CardMedia, Modal, useMediaQuery, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useEmblaCarousel from 'embla-carousel-react';

const Slide = ({ items }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);

  // Estados para los Dots
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'start',
    loop: true,
  });

  // Función para ir a un punto específico
  const scrollTo = useCallback((index) => emblaApi && emblaApi.scrollTo(index), [emblaApi]);

  // Lógica para actualizar el punto activo
  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    
    // Inicializar puntos y escuchar cambios
    setScrollSnaps(emblaApi.scrollSnapList());
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
    
    return () => emblaApi.off("select", onSelect);
  }, [emblaApi, onSelect]);

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);

  return (
    <>
      <Box sx={{ position: 'relative', width: '100%', px: { xs: 0, sm: 6 } }}>
        
        {!isMobile && (
          <>
            <IconButton onClick={scrollPrev} sx={{ position: 'absolute', left: 0, top: '40%', zIndex: 2, color: 'primary.main', bgcolor: 'rgba(255,255,255,0.8)' }}><ArrowBackIosNewIcon /></IconButton>
            <IconButton onClick={scrollNext} sx={{ position: 'absolute', right: 0, top: '40%', zIndex: 2, color: 'primary.main', bgcolor: 'rgba(255,255,255,0.8)' }}><ArrowForwardIosIcon /></IconButton>
          </>
        )}

        <Box ref={emblaRef} sx={{ overflow: 'hidden', width: '100%', mt: 2 }}>
          <Box sx={{ display: 'flex' }}>
            {items.map((item, index) => (
              <Box key={index} sx={{ flex: { xs: '0 0 100%', sm: '0 0 50%', md: '0 0 33.33%' }, minWidth: 0, px: 1 }}>
                <Card 
                  sx={{ width: { xs: "100%" }, cursor: 'pointer', borderRadius: 3, boxShadow: 'none', }}
                  onClick={() => { setModalIndex(index); setOpen(true); }}
                >
                  <CardMedia component="img" src={item.url} sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
                </Card>
              </Box>
            ))}
          </Box>
        </Box>

        {/* --- INDICADORES (DOTS) --- */}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 3 }}>
          {scrollSnaps.map((_, index) => (
            <Box
              key={index}
              onClick={() => scrollTo(index)}
              sx={{
                width: selectedIndex === index ? 24 : 8, 
                height: 8,
                borderRadius: 4,
                bgcolor: selectedIndex === index ? 'primary.main' : 'grey.400',
                cursor: 'pointer',
                transition: 'all 0.3s ease', 
                '&:hover': { bgcolor: 'primary.light' }
              }}
            />
          ))}
        </Box>
      </Box>

      <Modal open={open} onClose={() => setOpen(false)} sx={{ 
        display: 'flex', alignItems: 'center', justifyContent: 'center' 
      }}>
        <Box sx={{ 
          position: "relative", width: { xs: "90%", md: "70%" }, outline: 'none' 
        }}>
          <IconButton onClick={() => setOpen(false)} sx={{ position: "absolute", top: -45, right: 0, color: "white" }}>
            <CloseIcon fontSize="large" />
          </IconButton>
          <Box component="img" src={items[modalIndex]?.url} sx={{ 
            width: "100%", maxHeight: '80vh', objectFit: "contain", bgcolor: 'black', borderRadius: 2 
          }}/>
        </Box>
      </Modal>
    </>
  );
};

export default Slide;